// removed by extract-text-webpack-plugin
module.exports = {"profile-settings":"ProfileSettings__profile-settings___zwT6l","ie":"ProfileSettings__ie___2mbYm","preferred-login":"ProfileSettings__preferred-login___1mBhH"};